import request from '@/utils/request';
//条件查询发票列表
export function queryUserTicketList(query) {
  return request({
    url: '/api/system/userTicket/queryUserTicketList',
    method: 'post',
    data: query
  });
}
//新增发票
export function saveUserTicket(query) {
  return request({
    url: '/api/system/userTicket/saveUserTicket',
    method: 'post',
    data: query
  });
}
//删除发票
export function deleteUserTicket(query) {
  return request({
    url: '/api/system/userTicket/deleteUserTicket',
    method: 'post',
    data: query
  });
}
//查询单个
export function getUserTicket(query) {
  return request({
    url: '/api/system/userTicket/getUserTicket',
    method: 'post',
    data: query
  });
}
//获取发票手续费
export function queryShopServiceChargeList(query) {
  return request({
    url: '/api/system/shopServiceCharge/queryShopServiceChargeList',
    method: 'post',
    data: query
  });
}




// WEBPACK FOOTER //
// ./src/api/ticket/user.js